var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "vue-splash" } }, [
    _c("h1", [_vm._v(_vm._s(_vm.message))]),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "rsvp-button", on: { click: _vm.scrollToForm } },
      [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n    ")]
    ),
    _vm._v(" "),
    _c("button", {
      staticClass: "splash-chevron",
      on: { click: _vm.scrollToNextSection }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c7e54fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7e54fe","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/views/splash.vue
// module id = 66
// module chunks = 0